<template>
  <section class="privacy-section">
    <!-- 使用 column-count 实现双列瀑布流，自动排序 -->
    <div class="privacy-content">

      <!-- 标题与简介 -->
      <h1 class="main-title">Privacy Policy & Terms of Service <span class="gradient">(Updated 2026)</span></h1>
      <p class="intro-text">
        Fraud Counsel Department ("we", "our", or "us") is committed to protecting your personal information and
        maintaining the highest standards of data security, confidentiality, and regulatory compliance. This Privacy
        Policy explains how we collect, use, disclose, and safeguard your information when you access our website or
        engage our cryptocurrency recovery and fraud investigation services. By using our website or submitting your
        information, you agree to the practices outlined in this policy.
      </p>

      <!-- 1. Information We Collect -->
      <div class="item">
        <h2>1. Information We Collect</h2>
        <p>We collect only the information necessary to provide legitimate investigative and recovery-related services.
        </p>

        <h3>A. Personal Information</h3>
        <p>Information you voluntarily provide through forms, live chat, messaging platforms, or email:</p>
        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Wallet addresses (if applicable)</li>
          <li>Details related to your cryptocurrency case (e.g., transaction history, type of incident, estimated loss)
          </li>
        </ul>

        <h3>B. Technical & Usage Data</h3>
        <p>Automatically collected data includes:</p>
        <ul>
          <li>IP address and device identifiers</li>
          <li>Browser type and operating system</li>
          <li>Geographic region (approximate)</li>
          <li>Pages visited, session duration, and interactions</li>
          <li>Cookies and tracking identifiers</li>
        </ul>

        <h3>C. Communication Records</h3>
        <p>We retain:</p>
        <ul>
          <li>Emails, chat logs, and support tickets</li>
          <li>Documents or evidence submitted during investigations</li>
        </ul>
      </div>

      <!-- 2. How We Use Your Information -->
      <div class="item">
        <h2>2. How We Use Your Information</h2>
        <p>Your information is used strictly for legitimate operational purposes:</p>
        <ul>
          <li>Case evaluation and fraud investigation support</li>
          <li>Secure communication and case updates</li>
          <li>Website performance optimization</li>
          <li>Cybersecurity monitoring and fraud detection</li>
          <li>Compliance with legal and regulatory obligations</li>
        </ul>
        <p class="notice">Important Notice:<br>We will never request your private keys, seed phrases, or direct wallet
          access credentials.</p>
      </div>

      <!-- 3. Legal Basis for Processing (2026 Compliance) -->
      <div class="item">
        <h2>3. Legal Basis for Processing (2026 Compliance)</h2>
        <p>We process personal data under:</p>
        <ul>
          <li>Legitimate Interest — fraud detection, case assessment, and security</li>
          <li>User Consent — when you submit information voluntarily</li>
          <li>Legal Obligation — where required by law enforcement or regulatory authorities</li>
        </ul>
        <p>This aligns with global standards including:</p>
        <ul>
          <li>General Data Protection Regulation (GDPR)</li>
          <li>California Consumer Privacy Act / CPRA</li>
          <li>Other applicable international data protection laws</li>
        </ul>
      </div>

      <!-- 4. Information Sharing & Disclosure -->
      <div class="item">
        <h2>4. Information Sharing & Disclosure</h2>
        <p>We do not sell, trade, or rent your personal information.</p>
        <p>We may share data only when necessary with:</p>
        <ul>
          <li>Verified service providers (hosting, security, analytics)</li>
          <li>Legal, regulatory, or law enforcement agencies</li>
          <li>Internal compliance and fraud analysis teams</li>
        </ul>
        <p>All data sharing is strictly limited to what is necessary and legally justified.</p>
      </div>

      <!-- 5. Data Retention Policy (New 2026 Section) -->
      <div class="item">
        <h2>5. Data Retention Policy (New 2026 Section)</h2>
        <p>We retain personal data only as long as necessary:</p>
        <ul>
          <li>Active case data: retained during investigation</li>
          <li>Closed cases: retained for legal, audit, and compliance purposes (typically 3–7 years)</li>
          <li>Marketing/contact data: until you opt out or request deletion</li>
        </ul>
      </div>

      <!-- 6. Data Security Measures -->
      <div class="item">
        <h2>6. Data Security Measures</h2>
        <p>We implement enterprise-level protections including:</p>
        <ul>
          <li>End-to-end encryption protocols</li>
          <li>Secure servers and firewall protection</li>
          <li>Access control and authentication systems</li>
          <li>Continuous monitoring for unauthorized access</li>
        </ul>
        <p>While no system is 100% secure, we actively maintain and upgrade our infrastructure to mitigate risks.</p>
      </div>

      <!-- 7. Your Privacy Rights (Expanded for 2026) -->
      <div class="item">
        <h2>7. Your Privacy Rights (Expanded for 2026)</h2>
        <p>Depending on your location, you may have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Request correction or updates</li>
          <li>Request deletion ("Right to be Forgotten")</li>
          <li>Restrict or object to processing</li>
          <li>Request data portability</li>
          <li>Withdraw consent at any time</li>
        </ul>
        <p>To exercise these rights, contact us directly.</p>
      </div>

      <!-- 8. Cookies & Tracking Technologies -->
      <div class="item">
        <h2>8. Cookies & Tracking Technologies</h2>
        <p>We use cookies and similar technologies to:</p>
        <ul>
          <li>Improve website functionality</li>
          <li>Analyze user behavior</li>
          <li>Enhance fraud detection systems</li>
        </ul>
        <p>You can manage or disable cookies through your browser settings.</p>
      </div>

      <!-- 9. Third-Party Services -->
      <div class="item">
        <h2>9. Third-Party Services</h2>
        <p>Our website may include links to third-party platforms. We are not responsible for:</p>
        <ul>
          <li>External website content</li>
          <li>Third-party privacy practices</li>
        </ul>
        <p>Users are encouraged to review third-party policies independently.</p>
      </div>

      <!-- 10. International Data Transfers (New 2026 Section) -->
      <div class="item">
        <h2>10. International Data Transfers (New 2026 Section)</h2>
        <p>Your data may be processed outside your country of residence.</p>
        <p>When this occurs, we ensure:</p>
        <ul>
          <li>Adequate safeguards are in place</li>
          <li>Compliance with international data transfer regulations</li>
        </ul>
      </div>

      <!-- 11. Disclaimer of Guarantees (IMPORTANT – Legal Protection) -->
      <div class="item">
        <h2>11. Disclaimer of Guarantees (IMPORTANT – Legal Protection)</h2>
        <p>Fraud Counsel Department provides investigative and support services only. We do not guarantee recovery
          outcomes, as cryptocurrency transactions depend on multiple external factors including blockchain conditions,
          third-party platforms, and legal jurisdiction.</p>
      </div>

      <!-- 12. Policy Updates -->
      <div class="item">
        <h2>12. Policy Updates</h2>
        <p>We may update this policy to reflect:</p>
        <ul>
          <li>Legal or regulatory changes</li>
          <li>Technology upgrades</li>
          <li>Service improvements</li>
        </ul>
        <p>Updates will be posted with a revised effective date.</p>
      </div>

      <!-- 13. Contact Information -->
      <div class="item">
        <h2>13. Contact Information</h2>
        <p>Fraud Counsel Department<br>
          North American Client Support Office<br>
          250 International Pkwy, Lake Mary, FL 32746, USA</p>
        <p>Phone: +1 (934) 201-3499<br>
          Email: Admin@fraudcounsel.net</p>
        <p>Working Hours<br>
          Mon – Sat: 24 Hours<br>
          Sunday: 12:00 AM – 4:00 PM (EST)</p>
      </div>

      <h2 class="status">Secure. Confidential. Compliant. (2026 Standard)</h2>

    </div>
  </section>
</template>

<script>
export default {
  name: 'PrivacySection'
}
</script>

<style scoped>
/* 黑科技淡色风格 */
.privacy-section {
  background-color: #0b0b0f;
  padding: 80px 10%;
  color: #e2e8f0;
  font-family: sans-serif;
}

/* 双栏瀑布流布局：严格按1-13顺序从左列排满后自动进入右列 */
.privacy-content {
  column-count: 2;
  column-gap: 60px;
}

/* 防止条目在栏内被切断 */
.item,
.main-title,
.intro-text {
  break-inside: avoid;
}

/* 标题和简介 */
.main-title {
  font-size: 2.5rem;
  line-height: 1.3;
  margin: 0 0 20px;
  color: #fff;
}

.gradient {
  color: #4fd1c5;
}

.intro-text {
  font-size: 0.9rem;
  line-height: 1.8;
  color: #94a3b8;
  margin-bottom: 40px;
}

/* 条目内容 */
.item {
  margin-bottom: 30px;
}

.item h2 {
  font-size: 1.6rem;
  color: #fff;
  margin: 0 0 15px;
}

.item p {
  font-size: 0.9rem;
  color: #94a3b8;
  line-height: 1.8;
  margin: 0 0 10px;
}

.item h3 {
  font-size: 1.2rem;
  color: #8be9fd;
  margin: 20px 0 10px;
}

.item ul {
  margin: 0 0 15px;
  padding-left: 20px;
}

.item li {
  font-size: 0.9rem;
  color: #94a3b8;
  line-height: 1.6;
  margin-bottom: 8px;
}

.notice {
  color: #fbbf24;
  /* 淡黄色提示 */
  margin-top: 15px !important;
}

.status {
  color: #4fd1c5;
  font-weight: bold;
  margin-top: 20px;
}

/* 手机端响应式：变为单列，严格按照1-13顺序竖直展示 */
@media (max-width: 900px) {
  .privacy-section {
    padding: 50px 5%;
  }

  .privacy-content {
    column-count: 1;
    column-gap: 0;
  }

  .main-title {
    font-size: 2rem;
  }

  .item h2 {
    font-size: 1.4rem;
  }
}
</style>